module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    staticClass: "container"
  }, [(_vm.isShowContainer) ? _c('div', {
    staticClass: "mainContainer"
  }, [_c('a', {
    attrs: {
      "href": "#/app/newSong"
    },
    on: {
      "click": _vm.historyHight
    }
  }, [_c('span', {
    staticClass: "back"
  })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.data.title))]), _vm._v(" "), _c('section', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.imgurl,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("阅读:" + _vm._s(_vm.data.id))]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm.data.eiditetime))]), _vm._v(" "), _c('span', {
    staticClass: "focus",
    on: {
      "click": _vm.focusStatus
    }
  }, [_vm._v(_vm._s(_vm.word[_vm.num]))])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("文/" + _vm._s(_vm.data.author))]), _vm._v(" "), _c('section', {
    staticClass: "bottom"
  }, [_c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.data.mainContent))])]), _vm._v(" "), _c('section', {
    staticClass: "comment"
  }, [_c('div', [_c('span'), _vm._v(" "), _c('div', {
    staticClass: "sendComment"
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show"
    }],
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("评论")]), _vm._v(" "), _c('i', {
    staticClass: "commentIcon",
    on: {
      "click": _vm.watchComment
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "commentNum"
  }, [_vm._v(_vm._s(_vm.data.id))])]), _vm._v(" "), _c('span', {
    staticClass: "share"
  })])])]) : _vm._e(), _vm._v(" "), _c('xcomment')], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a102ff2"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/passageDetail.vue
// module id = 249
// module chunks = 0